module.exports = __webpack_public_path__ + "static/media/rishi.1ecd7e0e.svg";